import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { REPORT_ROUTE } from '../shared/constants/routes';
import { AuthGuard } from '../guards/auth.guard';
import { ReportComponent } from './report/report.component';

const routes: Routes = [
  {
    path: REPORT_ROUTE,
    component: ReportComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportRoutingModule {}
